import React from 'react';

export function StreamBankChartLegendItemIcon(props) {
    if(!props.DataSet) {
        return null;
    }
    let iconStyle = {
    };

    let className = "";

    if(props.DataSet.label) {
        if(props.DataSet.label === "Projects") {
            iconStyle.backgroundColor = props.DataSet.borderColor;
            className = "projects";
        } else if (props.DataSet.label.startsWith("Target ")) {
            iconStyle.borderBottomColor = props.DataSet.borderColor;
            className = "program-target";
        } else if (props.DataSet.label.startsWith("Implemented ")) {
            iconStyle.borderBottomColor = props.DataSet.borderColor;
            className = "implemented";
        } else if (props.DataSet.label.startsWith("Projected ")) {
            iconStyle.borderBottomColor = props.DataSet.borderColor;
            className = "projected";
        } else if (props.DataSet.label.startsWith("Milestone")) {
            iconStyle.backgroundColor = props.DataSet.borderColor;
            className = "milestones";
        }
    }

    return <div className={"sb-chart-legend-item-icon " + className} style={iconStyle} />;
}
